/**
 * GraphQL query to fetch head builder configuration from metaobjects
 * Retrieves all facial feature options for the "Create your own head" product
 */

const getHeadBuilderConfig = `
    query GetHeadBuilderConfig($handle: String!) {
        product(handle: $handle) {
            id
            title
            headConfig: metafield(namespace: "custom", key: "create_your_own_head_config") {
                value
                reference {
                    ... on Metaobject {
                        id
                        type
                        handle
                        
                        eyebrows: field(key: "eyebrows") {
                            references(first: 20) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        eyes: field(key: "eyes") {
                            references(first: 20) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        mouth: field(key: "mouth") {
                            references(first: 20) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        facialHair: field(key: "facial_hair") {
                            references(first: 10) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        moustacheStyles: field(key: "moustache") {
                            references(first: 20) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        beardStyles: field(key: "beard") {
                            references(first: 20) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        stubbleStyles: field(key: "stubble") {
                            references(first: 20) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        glasses: field(key: "glasses") {
                            references(first: 20) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        facialFeatures: field(key: "facial_feature") {
                            references(first: 20) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle
                                        title: field(key: "title") { value }
                                        image: field(key: "image") {
                                            reference {
                                                ... on MediaImage {
                                                    image {
                                                        url(transform: {maxWidth: 200})
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default getHeadBuilderConfig;
